import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import PmiTextField from 'shell/components/shared/text-field';
import { ForeignVM } from 'mutation/view-models/civil-union';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityForeignList, {
  MunicipalityForeignAnprVM,
} from 'shell/components/shared/municipality-foreign-list';

interface ForeignProps {
  onChange: (key: keyof ForeignVM, value: ForeignVM[keyof ForeignVM]) => void;
  values?: ForeignVM | null;
  errors: FormikErrors<ForeignVM>;
  touched: FormikTouched<ForeignVM>;
  disabled?: boolean;
}

const ForeignComponent = ({
  onChange,
  values,
  errors,
  touched,
  disabled,
}: ForeignProps): React.ReactElement => {
  const onChangeForeignStateList = useEventCallback((foreignState?: ForeignStateVM | null) => {
    onChange('foreignState', foreignState);
  });

  const handleMunicipalityListChange = useEventCallback(
    (municipality: MunicipalityForeignAnprVM | null) => {
      onChange('municipalityForeign', municipality);
    }
  );

  return (
    <Grid item xs={12} container spacing={1} alignItems="center">
      <Grid item xs={12} md={8}>
        <ForeignStateList
          value={values?.foreignState || null}
          onChange={onChangeForeignStateList}
          label="Stato estero"
          id="foreignState"
          error={touched?.foreignState && Boolean(errors?.foreignState)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <MunicipalityForeignList
          value={values?.municipalityForeign || null}
          onChange={handleMunicipalityListChange}
          label="Comune estero"
          id="municipalityForeign"
          disabled={disabled}
          foreignStateIstatCode={values?.foreignState?.id}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="provinceForeign"
          name="provinceForeign"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.provinceForeign || ''}
          onChange={(event) => onChange('provinceForeign', event.target.value)}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

ForeignComponent.displayName = 'Foreign component';

const Foreign = memo(ForeignComponent);

export default Foreign;
